import { createAction } from '@ngrx/store';

export const setCurrTab = createAction('[Cast Form] Set Current Form Tab', (tab: number) => ({ tab }));
